export default "__VITE_ASSET__goEfSL5V__"